module.exports = __webpack_public_path__ + "img/addresses.2b85abb3.svg";